<template>
  <div>
    <div :class="isLabau ? 'labau-map gmap-container' : 'gmap-container'">
      <!-- <button
        style="border: 0; padding: 15px; cursor: pointer;"
        @click="displayMap = !displayMap"
        v-if="!displayMap"
      >
        Load Map
      </button>-->
      <GmapMap
        class="gmap"
        ref="map"
        :center="center"
        :zoom="zoom"
        :options="mapOptions"
        @zoom_changed="setZoom"
      >
        <GmapCluster :styles="stylesCluster" @click="onClickCluster">
          <GmapMarker
            :key="index"
            v-for="(marker, index) in markers"
            :position="getLatLng(marker)"
            :options="{ list_position: index }"
            :clickable="true"
            :icon="stylesMarker"
            @click="toggleInfoWindow(marker, index)"
          />
        </GmapCluster>
        <GmapInfoWindow
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <Initiative
            :domain="domain"
            :vignette="infoWinContent.vignette"
            :themes="infoWinContent.themes"
            :title="infoWinContent.title"
            :link="infoWinContent.link"
            :key="infoWinContent.id"
            :single="true"
          />
        </GmapInfoWindow>
      </GmapMap>
      <div class="gmap__aside" ref="gmapAside">
        <button
          class="gmap__aside-close"
          @click="closeGmapAside"
          title="Fermer"
        ></button>
        <overlay-scrollbars>
          <div class="gmap__aside-text">
            <Initiative
              v-for="item in initiativeList"
              :domain="domain"
              :vignette="item.vignette"
              :themes="item.themes"
              :title="item.title"
              :link="item.link"
              :key="item.id"
            />
          </div>
        </overlay-scrollbars>
      </div>
      <div class="controls-list">
        <button class="btn" @click="setZoomMajor">
          <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.0237 0.472039V7.23704H14.4887V8.33204H8.0237V15.127H6.8537V8.33204H0.403702V7.23704H6.8537V0.472039H8.0237Z"
              fill="white"
            />
          </svg>
        </button>
        <button class="btn" @click="setZoomMinus">
          <svg
            width="17"
            height="2"
            viewBox="0 0 17 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.683092 0.474041H16.2471V1.32604H0.683092V0.474041Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
/* import { data } from "@/helpers/data"; */
import { gmapApi } from "vue2-google-maps";
import GmapMap from "vue2-google-maps/src/components/map";
import GmapMarker from "vue2-google-maps/src/components/marker";
import GmapCluster from "vue2-google-maps/src/components/cluster"; // replace src with dist if you have Babel issues
import GmapInfoWindow from "vue2-google-maps/src/components/infoWindow"; // replace src with dist if you have Babel issues
import Initiative from "@/components/Initiative.vue";

import "whatwg-fetch";

export default {
  name: "home",
  components: { GmapMap, GmapMarker, GmapCluster, GmapInfoWindow, Initiative },
  props: {
    isBlock: {
      default: false,
      type: [String, Boolean]
    },
    theme: {
      default: "All",
      type: String
    },
    title: {
      default: "",
      type: String
    },
    type: {
      default: "All",
      type: String
    },
    departement: {
      default: "All",
      type: String
    }
  },
  data() {
    return {
      /* displayMap: false, */
      isLabau: false,
      /* Gmap */
      center: { lat: 46.9374175, lng: 2.213749 },
      zoom: 6,
      mapOptions: {
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        minZoom: 1
      },

      /* Gmap Markers */
      markers: [],
      stylesMarker: {
        url: require("../assets/cluster.png")
      },

      /* Gmap Cluster */
      stylesCluster: [
        {
          url: require("../assets/cluster.svg"),
          width: 28,
          height: 40,
          anchorIcon: [40, 14],
          anchorText: [-5, 0],
          textColor: "#414042",
          fontWeight: "bold",
          fontFamily: "Ubuntu, sans-serif",
          textSize: 12
        },
        {
          url: require("../assets/cluster.svg"),
          width: 42,
          height: 60,
          anchorIcon: [60, 21],
          anchorText: [-9, 0],
          textColor: "#414042",
          fontWeight: "bold",
          fontFamily: "Ubuntu, sans-serif",
          textSize: 14
        }
      ],

      /* Gmap Data - GeoJson */
      dataGeoJsonRegions: null,
      dataStyles: {
        fillColor: "rgb(50, 131, 199)",
        fillOpacity: 0.3,
        strokeColor: "rgb(45, 107, 174)",
        strokeOpacity: 0.4
      },

      /* Gmap InfoWindow */
      infoWinContent: [],
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      domain: "https://odas.apriles.net/",
      initiativeList: [],

      /* Map param department */
      currentDepartement: "All"
    };
  },
  computed: {
    google: gmapApi
  },
  mounted() {
    if (window.location.hostname.includes("labau")) {
      this.isLabau = true;
    }

    if (this.isBlock) this.fetchInitiatives();
    const _that = this;

    parent.document.addEventListener("cat", e => {
      if (
        e.detail.departement !== "resetDept" &&
        this.currentDepartement != e.detail.switchDepartement
      ) {
        const detailDepartement = JSON.parse(e.detail.departement[0].json);

        this.currentDepartement = e.detail.switchDepartement;

        const bounds = new _that.google.maps.LatLngBounds();

        if (detailDepartement.geometry.type === "MultiPolygon") {
          for (
            let $i = 0;
            $i < detailDepartement.geometry.coordinates.length;
            $i++
          ) {
            for (
              let $j = 0;
              $j < detailDepartement.geometry.coordinates[$i].length;
              $j++
            ) {
              for (
                let $k = 0;
                $k < detailDepartement.geometry.coordinates[$i][$j].length;
                $k++
              ) {
                const departement =
                  detailDepartement.geometry.coordinates[$i][$j][$k];

                bounds.extend(
                  new _that.google.maps.LatLng(departement[1], departement[0])
                );
              }
            }
          }
        } else {
          for (
            let $i = 0;
            $i < detailDepartement.geometry.coordinates.length;
            $i++
          ) {
            for (
              let $j = 0;
              $j < detailDepartement.geometry.coordinates[$i].length;
              $j++
            ) {
              const departement =
                detailDepartement.geometry.coordinates[$i][$j];

              bounds.extend(
                new _that.google.maps.LatLng(departement[1], departement[0])
              );
            }
          }
        }

        this.$refs.map.$mapObject.fitBounds(bounds);
      }

      this.markers = e.detail.markers;
      this.closeGmapAside();
      this.infoWinOpen = false;
    });
  },
  methods: {
    fetchInitiatives() {
      const url = this.isLabau ? "export-rest-labau" : "export-rest";

      fetch(
        `/initiatives/${url}?theme=${this.theme}&title=${
          this.title !== "" ? this.title : ""
        }&type=${this.type}&departement=${this.departement}`
      )
        .then(res => res.json())
        .then(data => {
          this.markers = data;
        });
    },
    closeGmapAside() {
      this.initiativeList = [];
      this.$refs.gmapAside.classList.remove("gmap__aside--visible");
    },
    setZoom(e) {
      this.infoWinOpen = false;
      this.closeGmapAside();
      this.zoom = e;
    },
    getLatLng(marker) {
      const splitedMarkerLatLng = marker.geocode.split(",");

      return {
        lat: parseFloat(splitedMarkerLatLng[0]),
        lng: parseFloat(splitedMarkerLatLng[1])
      };
    },
    toggleInfoWindow: function(marker, idx) {
      this.closeGmapAside();
      // Center map
      this.$refs.map.$mapObject.panTo(this.getLatLng(marker));

      // Display infoWindow
      this.infoWindowPos = this.getLatLng(marker);
      this.infoWinContent = marker;

      if (this.currentMidx == idx) {
        // check if its the same marker that was selected if yes toggle
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    onClickCluster(event) {
      this.initiativeList = [];
      this.infoWinOpen = false;

      this.$refs.map.$mapObject.panTo({
        lat: event.center_.lat(),
        lng: event.center_.lng()
      });

      document
        .querySelector(".gmap__aside")
        .classList.add("gmap__aside--visible");

      event.markers_.forEach(el => {
        this.initiativeList.push(this.markers[el.list_position]);
      });
    },
    setZoomMinus() {
      this.$refs.map.$mapObject.setZoom(
        this.$refs.map.$mapObject.getZoom() - 1
      );
    },
    setZoomMajor() {
      this.$refs.map.$mapObject.setZoom(
        this.$refs.map.$mapObject.getZoom() + 1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Ubuntu:700&display=swap");

.gmap {
  max-width: 100%;
  width: 100vw;
  height: 100vh;

  &-container {
    position: relative;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
  }

  &__aside {
    z-index: 10000;
    overflow: auto;
    transition: transform cubic-bezier(1, 0.01, 0.68, 0.64) 0.25s;
    transform: translate3d(-101%, 0, 0);
    position: absolute;
    background: rgb(65, 64, 66);
    color: rgb(255, 255, 255);
    text-align: right;
    height: 100%;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 400px;

    &-close {
      cursor: pointer;
      display: inline-block;
      width: 15px;
      height: 15px;
      border: 0;
      padding: 0;
      margin: 1em;
      background: transparent url("../assets/close.png") no-repeat center center /
        contain;
      opacity: 0.6;
      outline: rgb(255, 255, 255) none medium;

      &:focus,
      &:hover,
      &:active {
        opacity: 1;
      }
    }

    &-text {
      max-height: calc(100vh - 38px);
      text-align: left;
      border-top: 1px solid rgb(255, 255, 255);
    }

    &--visible {
      transform: translate3d(0, 0, 0);
    }
  }
}

.controls-list {
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  align-self: end;
  position: absolute;
  bottom: 30px;
  right: 16px;
}

.btn {
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin: 2px;
  background: rgb(65, 64, 66);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 0;

  svg {
    transform: scale(0.8);
  }
}
</style>
